import LoggingIcon from '@mui/icons-material/EmojiPeopleTwoTone';
import AutomationsList from './AutomationsList';

export default {
    list: AutomationsList,
    icon: LoggingIcon
}